import { combineReducers } from 'redux';
import routerReducer from 'common/modules/app/router';
import { default as domainStateReducer } from 'common/modules/domain';
import { default as appStateReducer } from 'common/modules/app';

const appReducer = combineReducers({
  router: routerReducer,
  app: appStateReducer,
  domain: domainStateReducer
});
export default appReducer;
export type AppState = ReturnType<typeof appReducer>;
